var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"centerLeft1"}},[_c('div',{staticClass:"centerLeft1Title"},[_vm._v(" 行业类型统计 ")]),_c('div',{staticClass:"centerLeft1Box"},[_c('div',{ref:"chartInstance",attrs:{"id":"chartInstance"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }